export class Enumeration {
    public id: number = 0;
    public name: string = '';
}

export class EnumerationReply {
    public enumerations: Enumeration[] = [];
}

export class SlaTypeReply {
    public slaTypes: Enumeration[] = [];
}

export class JobPriorityReply {
    public jobPriorities: Enumeration[] = [];
}

export class JobTypeReply {
    public jobTypes: Enumeration[] = [];
}

export class JobStatusReply {
    public jobStatuses: Enumeration[] = [];
}

export class QuoteStatusReply {
    public quoteStatuses: Enumeration[] = [];
}

export class WorkStreamReply {
    public workStreams: Enumeration[] = [];
}

export class CostClaimableReply {
    public costClaimables: Enumeration[] = [];
}

export class CrewTypeReply {
    public crewTypes: Enumeration[] = [];
}

export class ContactTypeReply {
    public contactTypes: Enumeration[] = [];
}

export class TmUsageTypeReply{
    public tmUsageTypes: Enumeration[] = [];
}

export class FileTypesReply{
    public documentTypes: Enumeration[] = [];
}

export class FileStatusReply{
    public fileStatuses: Enumeration[] = [];
}

export class FileFoldersReply {
    public fileFolders: Enumeration[] = [];
}

export class NoteStatusReply{
    public noteStatuses: Enumeration[] = [];
}

export class BusStopReply{
    public busStopValues: Enumeration[] = [];
}

export class PermitStatusReply {
    public permitStatuses: Enumeration[] = [];
}

export class CouncilReply {
    public councils: Enumeration[] = [];
}

export class ExchangeReply {
    public exchanges: Enumeration[] = [];
}

export class PermitRequestStatusReply {
    public permitRequestStatuses: Enumeration[] = [];
}

export class DrawnByReply {
    public drawByValues: Enumeration[] = [];
}

export class DfeStatusReply {
    public dfeStatuses: Enumeration[] = [];
}

export class DfePartialReasonsReply {
    public dfePartialReasons: Enumeration[] = [];
}

export class CommercialStatusReply {
    public commercialStatuses: Enumeration[] = [];
}

export class ExternalInvoiceStatusReply {
    public externalInvoicesReceived: Enumeration[] = [];
}

export class FeeTypesReply {
    public feeTypes: Enumeration[] = [];
}
